var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('BaseLoading',{attrs:{"is-full-page":""}}):_c('FormWarehouse',{attrs:{"disabled-primary-button":_vm.isCreating,"warehouse-types":_vm.warehouseTypes},on:{"onSubmit":_vm.handleSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }